// ヒーローヘッダー　100vhのスマホ対応
function setHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setHeight();
// ブラウザのサイズが変更された時・画面の向きを変えた時に再計算する
// ※ブラウザのナビゲーションの表示切り替えにも反応してしまうため、通常は機能OFF
// window.addEventListener('resize', setHeight);


var menuState = false;
var dropState = false;

$(document).ready(function() {
  // 初期化
  sNavOut('.header__nav');

  // スライダー（slick）
  if($('.mainSlider').length){
    $('.mainSlider').slick({
      dots: true,
      arrow: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      lazyLoad: 'progressive',
    });
  }else{

  }
  if($('.contentsSlider').length){
    $('.contentsSlider').each(function() {

      var pcshow = $(this).data('pcshow') ? $(this).data('pcshow') : 4;
      var pcscroll = $(this).data('pcscroll') ? $(this).data('pcscroll') : 4;
      var spshow = $(this).data('spshow') ? $(this).data('spshow') : 2;
      var spscroll = $(this).data('spscroll') ? $(this).data('spscroll') : 2;
      var infinite = true;
      if($(this).hasClass('itemList--ranking')){infinite = false;}
      $(this).slick({
        dots: true,
        arrow: true,
        infinite: infinite,
        lazyLoad: 'progressive',
        slidesToShow: pcshow,
        slidesToScroll: pcscroll,
        autoplay: true,
        autoplaySpeed: 5000,
        speed:150,
        swipeToSlide:true,
        responsive: [{
          breakpoint: 991,  //ブレイクポイントを指定
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
          breakpoint: 768,
          settings: {
            slidesToShow: spshow,
            slidesToScroll: spscroll,
          }
        }]
      });
    });
  }
  if($('.mainSlider--typeB').length){
	  var slider = ".mainSlider--typeB"; // スライダー
	  var thumbnailItem = ".msThumbnail .msThumbnail__item"; // サムネイル画像アイテム

	  // サムネイル画像アイテムに data-index でindex番号を付与
	  $(thumbnailItem).each(function(){
	   var index = $(thumbnailItem).index(this);
	   $(this).attr("data-index",index);
	  });

	  // スライダー初期化後、カレントのサムネイル画像にクラス「thumbnail-current」を付ける
	  // 「slickスライダー作成」の前にこの記述は書いてください。
	  $(slider).on('init',function(slick){
	   var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
	   $(thumbnailItem+'[data-index="'+index+'"]').addClass("thumbnail-current");
	  });

	  //slickスライダー初期化
	  $(slider).slick({
	    autoplay: true,
	    arrows: true,
      infinite: true,
	  });
	  //サムネイル画像アイテムをクリックしたときにスライダー切り替え
	  $(thumbnailItem).on('click',function(){
	    var index = $(this).attr("data-index");
	    $(slider).slick("slickGoTo",index,false);
	  });

	  //サムネイル画像のカレントを切り替え
	  $(slider).on('beforeChange',function(event,slick, currentSlide,nextSlide){
	    $(thumbnailItem).each(function(){
	      $(this).removeClass("thumbnail-current");
	    });
	    $(thumbnailItem+'[data-index="'+nextSlide+'"]').addClass("thumbnail-current");
	  });
	}

  if($('.mainVisual--integrate').length && $('.hdr--integrate').length){
    $('.hdr--integrate').addClass('active');
    $(window).on('scroll', function(event) {
      var scroll = $(window).scrollTop();
      if (scroll > 300 ){
        $('.hdr--integrate').addClass('integrate--fixed');
      }else{
        $('.hdr--integrate').removeClass('integrate--fixed');
      }
    });

  }

});

// ハンバーガーメニュー展開
$(document).on('click', '.menuToggle', function() {
  $('#drawer').toggleClass('open');
  $('#overlay').toggleClass('open');
  $('body').toggleClass('open');
  return false;
});

$(document).on('click', '.menuClose', function() {
  $('#drawer').removeClass('open');
  $('#overlay').removeClass('open');
  $('body').removeClass('open');
  return false;
});

// SPのみアコーディオン
$(document).on('click', '.sp-toggle', function() {
  var windowWidth = $(window).width();
  if (windowWidth < 768) {
    $(this).next('ul').slideToggle();
    $(this).toggleClass('open');
  }
});

$(document).on('click', '.hdrSearch--toggle > span,.hdrSearch--toggle > a', function() {
  $(this).next().slideToggle();
  if($(this).find('.material-icons').text() == 'search'){
    $(this).find('.material-icons').text('close');
  }else if($(this).find('.material-icons').text() == 'close'){
    $(this).find('.material-icons').text('search');
  }
  return false;
});


// ナビゲーション　子要素展開
$(function() {
  var ua = navigator.userAgent;
  // タブレット・スマートフォン時
  if ((ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0||ua.indexOf('iPad') > 0) {
    $('.hasChildren > a').on('mouseenter touchstart', function(){
      $(this).toggleClass('open');
      $(this).next('ul,.megaMenu').toggleClass('open');
      return false;
    }).on('mouseleave touchend', function(){
          return false;
    });
    $('.hasChildren .hasChildren--close > a').on('mouseenter touchstart', function(){
      $(this).parents('ul').removeClass('open').prev('a').removeClass('open');
      return false;
    });

  }else{
  // PC時
    $('.hasChildren').hover(function() {
      $(this).children('a').addClass('open');
      $(this).children('ul,.megaMenu').addClass('open');
    }, function() {
      $(this).children('a').removeClass('open');
      $(this).children('ul,.megaMenu').removeClass('open');
    });
  }
});

$(document).on('click', '.hasChildren--click > a,.hasChildren--click > span', function() {
  if (dropState == false) {
    $(this).addClass('open');
    $(this).next('ul').addClass('open');
    $(this).next('ul').slideDown();
    dropState = true;
  } else {
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).next('ul').removeClass('open');
      $(this).next('ul').slideUp();
    } else {
      $(this).parents('li').parents('ul').parents('.gNav').find('.hasChilds > span').removeClass('open');
      $(this).parents('li').parents('ul').parents('.gNav').find('.hasChilds > span').next('ul').removeClass('open');
      $(this).parents('li').parents('ul').parents('.gNav').find('.hasChilds > span').next('ul').slideUp(0);
      $(this).addClass('open');
      $(this).next('ul').addClass('open');
      $(this).next('ul').slideDown();
    }
  }
  return false;
});

// SPヘッダーD　カテゴリーナビ
$(document).on('click', '.hdrCatMenu--toggle', function() {
  if($(this).hasClass('open')){
    $(this).removeClass('open');
    $(this).next('ul').removeClass('open');
    $(this).next('ul').slideUp();
  }else{
    $('.hdrCatMenu--toggle.open').next('ul').hide();
    $('.hdrCatMenu--toggle.open').next('ul').removeClass('open');
    $('.hdrCatMenu--toggle.open').removeClass('open');
    $(this).addClass('open');
    $(this).next('ul').addClass('open');
    $(this).next('ul').slideDown();
  }
  return false;
});


// ナビ固定
$(function() {
  // 共通
  if($(".hdrFixed").length){
    hdrFixed($(".hdrFixed"));
  }else{
    var ua = navigator.userAgent;
    // タブレット・スマートフォン時
    if ((ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0||ua.indexOf('iPad') > 0) {
      if($(".hdrFixed--sp").length){
        hdrFixed($(".hdrFixed--sp"));
      }
    // PC
    }else{
      if($(".hdrFixed--pc").length){
        hdrFixed($(".hdrFixed--pc"));
      }
    }
  }

  function hdrFixed(target){
    target.after('<div class="h_box"></div>');
    var h = target.height();
    var h_top = target.offset().top;
    $(".h_box").height("0");
    $(window).on('load scroll resize', function(event) {
      var scroll = $(window).scrollTop();
      if (scroll >= h_top) {
        target.css({
          position: 'fixed',
          top: '0px',
          width: '100%',
          'z-index': '998'
        });
        $(".h_box").height(h);
      } else {
        target.css({
          position: ''
        });
        $(".h_box").height("0");
      }
    });
  }
});


function sNavIn(_this) {
  var windowWidthMinus = document.documentElement.clientWidth * -1;
  $(_this).addClass('open');
  $('.menuBg--close').addClass('open');
  $(_this).css({
    'left': 0
  });
}

function sNavOut(_this) {
  var windowWidthMinus = document.documentElement.clientWidth * -1;
  $(_this).removeClass('open');
  $('.menuBg--close').removeClass('open');
  $(_this).css({
    'left': windowWidthMinus
  });
}

// タブ切り替え
// $(function() {
//   $(".tabSwitch > li ").click(function() {
//     if (!$(this).hasClass('active')) {
//       $(this).parents('.tabSwitch').find('li').removeClass('active');
//       $(this).addClass('active');

//       var tabNum = $(this).index();
//       $(this).parents(".tab").find(".tabContents").find(".tabContent").hide();
//       $(this).parents(".tab").find(".tabContents").find(".tabContent").eq(tabNum).fadeIn("500");
//     }
//   });
// });

// タブ切り替え
$(function() {
	$('.tab > li').each(function() {
		$(this).appendTo(".tabSwitch");
	});
	$('.tab > .tabContent').each(function() {
		$(this).appendTo(".tabContents");
	});
	$('.tabSwitch-js li:first-child').addClass('active');
	$('.tabContents-js .tabContent:first-child').addClass('active');
  $(".tabSwitch > li ").click(function() {
    if (!$(this).hasClass('active')) {
      $(this).parents('.tabSwitch').find('li').removeClass('active');
      $(this).addClass('active');

      var tabNum = $(this).index();
      $(this).parents(".tab").find(".tabContents").find(".tabContent").hide();
      $(this).parents(".tab").find(".tabContents").find(".tabContent").eq(tabNum).fadeIn("500");
    }
  });
});

// スクロールボタン
$(function() {
  if ($('.mainSliderSec').length || $('.mainVisual').length) {
    if($('.mainVisual--hero').length){
      var position = $(window).height();
    }else if ($('.mainSliderSec').length) {
      var position = $(".mainSliderSec + * ").offset().top;
    }else{
      var position = $(".mainVisual + * ").offset().top;
    }
    $("#scrollBtn").click(function() {
      $("html,body").animate({
        scrollTop: position // さっき変数に入れた位置まで
      }, {
        queue: false // どれくらい経過してから、アニメーションを始めるか。キュー[待ち行列]。falseを指定すると、キューに追加されずに即座にアニメーションを実行。
      });
      return false;
    });
  }
});

// TOPに戻るボタン
$(function(){
  if($('#toTop').length){
    var topBtn = $('#toTop');
    topBtn.hide();

    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
      var w = $(window).width();
      if ($(this).scrollTop() > 800) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    });

    //スムーススクロールでページトップへ
    topBtn.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 500);
      return false;
    });
  }
});

// 検索ランキングキーワード
$(function() {
  // テキストボックスにフォーカス時、フォームの背景色を変化
  $('.keywordRanking input[type="text"]')
    .focusin(function(e) {
      $(this).parents('.keywordRanking').next('.keywordRanking__toggle').addClass('open');
    })
    .focusout(function(e) {
      setTimeout(function(){
        $('.keywordRanking__toggle.open').removeClass('open');
        console.log($('.keywordRanking__toggle.open'));
      },200);
    });
});

// テキスト横スクロール
var spSwiperDone = false;
$(window).on('load resize', function(event) {
  if (window.innerWidth < 992 && spSwiperDone == false && $(".spSwiper").length) {
    $('.spSwiper').slick({
      autoplay: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      variableWidth: true,
      touchMove: true,
      swipeToSlide: true,
      infinite: false
    });

    spSwiperDone= true;
  }
});

if($(".wow").length){
  $(window).on('scroll',function(){
    $(".wow").each(function(){
      var position = $(this).offset().top;
      var height = $(this).height();
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > position - windowHeight + windowHeight / 4 ){
        $(this).addClass('animated');
      }
    });
  });
}

if (window.innerWidth < 767) {
  $(".cateList__hasChildren").click(function() {
    $(this).toggleClass('open').next().toggleClass('open').slideToggle();
    return false;
  });
}

// ＊＊＊＊＊＊＊
// CMS固有
// ＊＊＊＊＊＊＊

// コマクリの商品カルーセル解除
// if($(".wow").length){
// $('.fs-c-productListCarousel__list__itemTrack').each(function() {
//   // 商品表示パーツのクラスを付与
//   $(this).addClass('itemList itemList--typeC itemList-pc--4 itemList-sp--2');
//   $(this).parents('.fs-c-productListCarousel__list').removeClass('fs-c-productListCarousel__list').addClass('ccItemListContainer');
//   $(this).removeClass('fs-c-productListCarousel__list__itemTrack');
//   $(this).find('article.fs-c-productListCarousel__list__item.fs-c-productListItem').each(function() {
//     $(this).removeClass('fs-c-productListCarousel__list__item fs-c-productListItem').addClass('itemList__unit');
//     // 商品名
//     var name = $(this).find('.fs-c-productListItem__productName .fs-c-productName__name').text();
//     // 画像をdataLazyから抽出してパース
//     var dataLazy = '';
//     var img = '';
//     $(this).find('img.fs-c-productImage__image').each(function() {
//       dataLazy = $(this).attr('data-lazy');
//       $(this).attr('src', dataLazy);
//     });
//     if (dataLazy != '') {
//       img = '<img src="' + dataLazy + '" alt="' + name + '" class="itemImg" />';
//     }
//     // 商品URL
//     var url = $(this).find('.fs-c-productListItem__productName a').attr('href');
//     // 価格
//     var price = $(this).find('.fs-c-productListItem__prices.fs-c-productPrices').html();
//     // 在庫表示
//     var stockClass = $(this).find('.fs-c-productListItem__lowInStock.fs-c-productListItem__notice.fs-c-productStock').attr('class');
//     console.log(stockClass);
//     var stock = $(this).find('.fs-c-productListItem__lowInStock.fs-c-productListItem__notice.fs-c-productStock').html();
//     if (stock != undefined) {
//       stock = '<div class="' + stockClass + '">' + stock + '</div>';
//     } else {
//       stock = '';
//     }
//     // ボタン＆お気に入り
//     var btn = $(this).find('.fs-c-productListItem__control.fs-c-buttonContainer');
//     // パース
//     var html = '<a class="itemWrap" href="' + url + '">' + img + '<p class="itemName">' + name + '</p>' + price + stock + '</a>';
//
//     $(this).html(html);
//
//     $('.fs-c-productListCarousel__ctrl').hide();
//   });
//
//   $('.fs-c-button--carousel').hide();
// });

// クリモ検索エンター
$('.search-keyword').on('keypress', function(e) {
    if (e.keyCode == 13) {
        var index = $('.search-keyword').index(this);
        $('.search-url')[index].click();
    }
});

// クリモカレンダー
$(function(){
    $('.dayList').each(function(){
        var month = $(this).attr('data-month');
        var day = $(this).attr('data-day');
        var color = $(this).attr('data-color');
        $('.makeshop-calendar' + month +' .day' + day).css({
            'background-color': color,
            'color': '#fff',
            'font-weight': 'bold'
        });
    });
});



// _creatorMode Cart
$('#cp_toggle01_bg').on('click', function() {
  console.log('a');
    if($('#cp_toggle01').prop('checked')){
        $('#cp_toggle01').prop('checked', false);
      }
    if($('#cp_toggle04').prop('checked')){
        $('#cp_toggle04').prop('checked', false);
    }
});
$('.cp_toggle04').on('click', function() {
  if ($('#cp_toggle01').prop('checked')) {
    $('#cp_toggle01').prop('checked', false);
  }
});

$('.cp_toggle01').on('click', function() {
  if ($('#cp_toggle04').prop('checked')) {
    $('#cp_toggle04').prop('checked', false);
  }
});

function updateCart(data)
{
    // 買い物カゴの商品数を更新
    var quantity = getCartQuantity(data.totalQuantity);
    $('.cartAmount', parent.document).html(quantity);

    // 買い物カゴをリロード
    var url = $('.cart-object', parent.document).attr('data');
    $('.cart-object', parent.document).attr('data', url);
}

// 買い物カゴの商品数を取得する（商品詳細ページでも利用）
function getCartQuantity(totalQuantity)
{
    var quantity = '';

    if (totalQuantity == 0) {
        quantity = '';
    } else if (totalQuantity < 100) {
        quantity = totalQuantity;
    } else {
        quantity = '99+';
    }

    return quantity;
}

$(function() {
  if($('#catepage-page-common-search-data').length){
    initCustomSearchForm($('#catepage-page-common-search-data'));
  }
  if($('#side-page-common-search-data').length){
    initCustomSearchForm($('#side-page-common-search-data'));
  }
  if($('#drawer-page-common-search-data').length){
    initCustomSearchForm($('#drawer-page-common-search-data'));
  }
});

function initCustomSearchForm(pageData)
{
    var searchUrl = pageData.attr('data-search-url');
    var keywordId = pageData.attr('data-id-keyword');
    var priceLowId = pageData.attr('data-id-price-low');
    var priceHighId = pageData.attr('data-id-price-high');
    var categoryId = pageData.attr('data-id-category');
    var originalCodeId = pageData.attr('data-id-original-code');

    $('[href="' + searchUrl + '"]').on('click', function() {
        var index = $('[href="' + searchUrl + '"]').index(this);
        var keyword = getFormValue(keywordId, index);
        var priceLow = getFormValue(priceLowId, index);
        var priceHigh = getFormValue(priceHighId, index);
        var category = getFormValue(categoryId, index);
        var originalCode = getFormValue(originalCodeId, index);

        $.ajax({
            url: '/shop/shopsearch_url.html',
            type: 'POST',
            data: JSON.stringify({
                'keyword': keyword,
                'price_low': priceLow,
                'price_high': priceHigh,
                'category': category,
                'original_code': originalCode
            }),
            contentType: 'application/json',
            dataType: 'json'
        }).done(function(data) {
            if (!data.result) {
                openModalMessage(data.error.message);
                return;
            }
            location.href = data.url;
        });

        return false;
    });
}

function getFormValue(dataId, index)
{
    var result = $('[data-id="' + dataId + '"]').eq(index).val();
    return (result === undefined) ? '' : result;
}

// FAQ
$(document).on('click', '.faqWrap:not(.faqWrap--noJS) dt', function() {
  $(this).toggleClass('open').next('dd').slideToggle(0);
});